<template>
    <div :class="{['billing-information-popup'] :true,['hide'] : popupOpen !== 'billingInformation'}">
        <div class="popup" ref="billingInformationPopup">
            <div class="title-section">
                <h2>{{ $t('dash.settings.billing.card.billing_information.billing_information.title') }}</h2>
                <p>{{ $t('dash.settings.billing.edit_billing.subtitle') }}</p>
            </div>

            <div class="content-form">
                <div class="container-input business">
                    <label>{{  $t('dash.settings.billing.edit_billing.business.label') }}</label>
                    <div class="input">
                        <i class="fa-solid fa-briefcase"></i>
                        <input :placeholder="$t('dash.settings.billing.edit_billing.business.placeholder')" v-model="formInfoAccount.company">
                    </div>
                </div>
                <div class="container-input adress">
                    <label>{{ $t('dash.settings.billing.edit_billing.localisation.label') }}</label>
                    <div class="input">
                        <i class="fa-solid fa-house-user"></i>
                        <input :placeholder="$t('dash.settings.billing.edit_billing.localisation.placeholder')" v-model="formInfoAccount.address">
                    </div>
                </div>

                <div class="container-input adress">
                    <label><span>{{ $t('dash.settings.billing.edit_billing.country.label') }}</span> <span>{{ $t('dash.settings.billing.edit_billing.zipcode.label') }}</span> <span>{{ $t('dash.settings.billing.edit_billing.city.label') }}</span></label>
                    <div class="inputs">
                        <div class="input">
                            <i class="fa-solid fa-earth-americas"></i>
                            <input :placeholder="$t('dash.settings.billing.edit_billing.country.placeholder')" v-model="formInfoAccount.country">
                        </div>
                        <div class="input">
                            <i class="fa-solid fa-location-dot"></i>
                            <input :placeholder="$t('dash.settings.billing.edit_billing.zipcode.placeholder')" v-model="formInfoAccount.zipcode">
                        </div>
                        <div class="input">
                            <i class="fa-solid fa-city"></i>
                            <input :placeholder="$t('dash.settings.billing.edit_billing.city.placeholder')" v-model="formInfoAccount.city">
                        </div>
                    </div>
                </div>

                <div class="container-input tva">
                    <label>{{ $t('dash.settings.billing.edit_billing.tva.label') }}</label>
                    <div class="input">
                        <i class="fa-solid fa-tag"></i>
                        <input :placeholder="$t('dash.settings.billing.edit_billing.tva.placeholder')" v-model="formInfoAccount.vat_number">
                    </div>
                </div>
            </div>

            <div class="btns">
                <div class="btn-outline-primary" @click="cancel" v-if="formInfoAccountIsModified()">{{ $t('dash.button.cancel') }}</div>
                <div class="btn-primary icon-r" @click="save">{{ $t('dash.button.save') }}</div>
            </div>
        </div>
    </div>
     
</template>

<script>

export default {
    name: 'BillingInformationPopup',

    props : {
        closePopUp : Function,
        popupOpen : String,
        infoAccount : Object,
        updateInfoAccount : Function,
    },

    data() {
        return {
            formInfoAccount : {},
        };
    },

    mounted() {
      this.formInfoAccount = {...this.infoAccount};
    },

    watch : {
        popupOpen() {
            if (this.popupOpen === 'billingInformation') {   
                window.addEventListener('click', this.handleClickOutside);
            }else{
                window.removeEventListener("click", this.handleClickOutside, false);
            }
        },
        infoAccount() {
            this.formInfoAccount = {...this.infoAccount};
        },
    },


    methods: {
        handleClickOutside(event) {
            const targetElement = this.$refs.billingInformationPopup;
            if (!targetElement.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutside, false);
                this.closePopUp()
            }
        },

        cancel(){
            this.formInfoAccount = {...this.infoAccount};
            this.closePopUp()
        },

        async save(){
          
            if (this.formInfoAccountIsModified()) {
                let bodyInfoAccount = {
                    id: this.infoAccount.id,
                    company: this.formInfoAccount.company,
                    address: this.formInfoAccount.address,
                    zipcode: this.formInfoAccount.zipcode,
                    city: this.formInfoAccount.city,
                    vat_number: this.formInfoAccount.vat_number,
                    country: this.formInfoAccount.country,
                }
                const resultSaveInfoAccount = await this.updateInfoAccount(bodyInfoAccount)
                if(!resultSaveInfoAccount) {
                    this.$vs.notify({
                        title: this.$t('dash.notifications.error_title'),
                        text: this.$t('dash.notifications.error_body'),
                        color:'error'
                    })
                }else{
                    this.$vs.notify({
                        title: this.$t('dash.notifications.success_title'),
                        color:'success'
                    })
                }
            }

            this.closePopUp()
            
        
        },

        formInfoAccountIsModified(){
            const propertys = ['company','address','zipcode','city','vat_number','country']
            return propertys.some(propertys => {
                return this.formInfoAccount[propertys] !== this.infoAccount[propertys]
            })
        },
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>
